const useAncestors = (
  nodes: TreeListItemTsoPqProps[],
  pathToNode: string[] = []
): Record<string, string[]> => {
  const ancestorMap: Record<string, string[]> = {};

  const collectAncestors = (
    currentNodes: TreeListItemTsoPqProps[],
    ancestors: string[]
  ) => {
    for (const node of currentNodes) {
      // Store the ancestor list for this node
      ancestorMap[node.id] = [...ancestors];

      // Recurse into children if they exist
      if (node.options) {
        collectAncestors(node.options, [...ancestors, node.id]);
      }
    }
  };

  collectAncestors(nodes, pathToNode);
  return ancestorMap;
};

export default useAncestors;